"use strict";
import $ from "jquery";
export default class RecommendationSearchPage {
  constructor() {
    this.name = "recommendation-search-page";
    // console.log("%s module", this.name.toLowerCase());
    let clearBtn = '<div class="clear-btn-wrapper"><button class="clear-btn"><span aria-hidden="true" class="icon"></span>Clear Filters</button></div>'
    var clearButtonDisplay = document.getElementsByClassName("clear-btn-wrapper");
    var searchBtn = '<button class="search-btn"> search </button>';
    $(
      ".path-state-infrastructure-strategy .block-views-exposed-filter-blockrecommendation-search-page-1 .form-type-textfield.js-form-item-combine input"
    ).after(searchBtn);

    $(
      ".path-state-infrastructure-strategy .block-views-exposed-filter-blockrecommendation-search-page-1 .form-type-textfield.js-form-item-combine input"
    ).after(searchBtn);

    $('.block-views-exposed-filter-blockrecommendation-search-page-1 form', function() {
      toggleButton();
    }).prepend(clearBtn);

    $('body').on('click', '.block-views-exposed-filter-blockrecommendation-search-page-1 form li',function(){
      toggleButton();
    })

    $(".form-text").on('keypress', function(button) {
      if (button.key == "Enter") {
        document.getElementById("views-exposed-form-recommendation-search-page-1").submit();
      }
      toggleButton();
    })

    $('body').on('click', '.block-views-exposed-filter-blockrecommendation-search-page-1 form .clear-btn',function(e){
      e.preventDefault();
      jQuery('.block-views-exposed-filter-blockrecommendation-search-page-1 select[multiple] option').removeAttr('selected');
      jQuery('.block-views-exposed-filter-blockrecommendation-search-page-1 select[multiple]').multiselect('reload');
      toggleButton();
    })

    toggleButton();
    function toggleButton() {
      if(jQuery('.block-views-exposed-filter-blockrecommendation-search-page-1 .js-form-type-select .selected').length == 0) {
        clearButtonDisplay[0].style.display = "none";
      } else {
        clearButtonDisplay[0].style.display = "block";
      }
    }
    
    jQuery('.block-views-exposed-filter-blockrecommendation-search-page-1 select[multiple]').multiselect();
  }
}
